import { FC } from 'react';

import type { IconProps } from './types';

export const WarningIcon: FC<IconProps> = ({ size = 20, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.1852 4.65982L2.95191 17.1878C2.14524 18.5852 3.15324 20.3332 4.76791 20.3332H19.2346C20.8492 20.3332 21.8572 18.5865 21.0506 17.1878L13.8172 4.65982C13.0106 3.26248 10.9919 3.26248 10.1852 4.65982Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0039 8.6665V13.3332"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0013 18.0915C11.2653 18.0915 10.668 17.4928 10.668 16.7581C10.668 16.0235 11.2653 15.4248 12.0013 15.4248C12.7373 15.4248 13.3346 16.0235 13.3346 16.7581C13.3346 17.4928 12.7373 18.0915 12.0013 18.0915Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default WarningIcon;
